<!--
 * @Description: 
 * @Date: 2020-09-24 20:03:35
-->
<template>
  <ul class="tab">
    <li
      v-for="(item,index) in tabs"
      :key="index"
      :class="[index === value ? 'active' : '']"
      @click="changeTab(item,index)"
    >{{item}}</li>
  </ul>
</template>

<script>
import { getUserCollectList } from '@/api/ajax';
export default {
  props: {
    tabs: {
      type: Array,
      default() {
        return [];
      }
    },
    value: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      // tabs: ['收藏的文章', '收藏的视频'],
      activeIndex: 0
    };
  },
  components: {},
  watch: {},
  computed: {},
  methods: {
    changeTab(item, index) {
      this.$emit('input', index);
    }
  }
};
</script>

<style scoped lang='less'>
.tab {
  display: flex;
  li {
    width: 50%;
    border-radius: 0.21rem;
    border: 0.04rem solid #3667ec;
    text-align: center;
    padding: 0.32rem 0;
    font-size: 0.43rem;
    touch-action: none;
    line-height: 1;
    &:first-child {
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
      border-right: 0;
    }
    &:last-child {
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
      border-left: 0;
    }
  }
  .active {
    background: #3667ec;
    color: #fff;
  }
}
</style>
